<template>
  <div class="repairReq-main">
    <div class="repairReq-main-header">
      <p class="font-format-big text-center">请确认您的寄收和收货信息</p>
    </div>
    <div class="repairReq-main-step4">
      <el-row class="repairReq-main-step4-row">
        <el-col
          :xl="8"
          :lg="8"
          :md="8"
          :sm="24"
          class="repairReq-main-step4-left"
        >
          <p class="font-format-normal">请选择寄回方式及地址信息</p>
        </el-col>
        <el-col
          :xl="14"
          :lg="14"
          :md="14"
          :sm="24"
          class="repairReq-main-step4-right"
        >
          <div class="repairReq-step4-typeSelect text-center">
            <el-radio-group v-model="selectType" @change="selectChange">
              <el-radio v-model="selectType" :label="1"
                ><span class="font-format-normal">预约上门取件</span>
              </el-radio>
              <el-radio v-model="selectType" :label="2"
                ><span class="font-format-normal">自行邮寄</span></el-radio
              >
            </el-radio-group>
          </div>
          <div v-if="selectType === 1" class="repairReq-step4-address">
            <p class="font-format-medium">
              请新增或选择地址，若地址为灰色，则不在顺丰上门取件服务范围，建议更改地址或自行邮寄。
            </p>
            <div class="repairReq-step4-address-info">
              <div class="repairReq-step4-address-content"></div>
              <el-button
                type="primary"
                size="default"
                @click="showAddressDialog"
              >
                新增地址
              </el-button>
            </div>
            <div class="repairReq-step4-CollectionTime">
              <p class="font-format-medium">请选择您方便的上门取件时间</p>
              <el-date-picker
                v-model="collectionData"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
              <el-select v-model="collectionTime" placeholder="选择时间">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="repairReq-step4-address-tips">
              <p class="font-format-medium">寄件需知：</p>
              <p class="font-format-medium">
                1、如只是机器故障，只需寄出机器即可，数据线、保护套、电磁笔等配件无需寄回，避免回寄出现丢失，破损等意外情况，感谢您的理解。
              </p>
              <p class="font-format-medium">
                2、寄修前请自行做好数据备份，因维修导致的数据丢失，文石概不负责；
              </p>
              <p class="font-format-medium">
                3、快件打包请注意保护好屏幕，避免运输中有损坏；
              </p>
              <p class="font-format-medium">
                4、设备屏幕如有贴膜，如需换屏，屏膜将无法重贴；
              </p>
              <p class="font-format-medium">
                5、寄送前请在包裹内附上包含姓名和手机的纸条，方便查询；
              </p>
              <p class="font-format-medium">
                6、经文石检测确认后，需付费维修的设备，从文石发起付费通知七个工作日后如仍未付费确认维修，文石售后维修中心会将设备原路寄回；
              </p>
              <p class="font-format-medium">
                7、运费双方各支付一程，请勿寄到付，到付拒收；
              </p>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row class="repairReq-main-step4-row">
        <el-col
          :xl="8"
          :lg="8"
          :md="8"
          :sm="24"
          class="repairReq-main-step4-left"
        >
          <p class="font-format-normal">请填写您的收货地址（维修后寄回用）</p>
        </el-col>
        <el-col
          :xl="14"
          :lg="14"
          :md="14"
          :sm="24"
          class="repairReq-main-step4-right"
        >
          <el-checkbox
            v-if="selectType === 1"
            v-model="isSameAddress"
            @change="sameCheckChange"
            ><span class="font-format-normal">与寄件地址相同</span>
          </el-checkbox>

          <el-collapse-transition>
            <div class="repairReq-step4-address" v-if="showReceiverAddressBtn">
              <p class="font-format-medium"></p>
              <div class="repairReq-step4-address-info">
                <div class="repairReq-step4-address-content"></div>
                <el-button
                  type="primary"
                  size="default"
                  @click="showAddressDialog"
                >
                  新增地址
                </el-button>
              </div>
            </div>
          </el-collapse-transition>
        </el-col>
      </el-row>
    </div>
    <div class="repairReq-step4-next">
      <el-button type="text" @click="goBack">返回上一步</el-button>
      <el-button type="primary" size="default" @click="nextPage"
        >下一步</el-button
      >
      <div></div>
    </div>

    <el-dialog
      class="address-dialog"
      title="新增地址"
      :visible.sync="addressDialogVisible"
      @close="closeDialog"
    >
      <div class="address-dialog-form">
        <el-form
          :model="form"
          ref="form"
          :rules="rules"
          :inline="false"
          label-position="top"
          size="small"
        >
          <el-form-item label="姓名">
            <el-input v-model="form.name" placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机">
            <el-input v-model="form.phone" placeholder="手机"></el-input>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="form.email" placeholder="邮箱"></el-input>
          </el-form-item>
          <el-form-item label="省份|城市|区/县|街道/乡镇">
            <el-input
              v-model="form.area"
              placeholder="省份|城市|区/县|街道/乡镇"
            ></el-input>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input v-model="form.address" placeholder="详细地址"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer">
        <el-button @click="addressDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="addressHandle">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectType: 1,
      collectionData: "",
      collectionTime: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      isSameAddress: true,
      addressDialogVisible: false,
      showReceiverAddressBtn: false,
      form: {
        name: "",
        phone: "",
        email: "",
        area: "",
        address: "",
      },
    };
  },
  methods: {
    goBack() {
      this.$emit("goBack");
    },
    nextPage() {
      this.$emit("nextPage");
    },
    showAddressDialog() {
      this.addressDialogVisible = true;
    },
    sameCheckChange() {
      this.showReceiverAddressBtn = !this.isSameAddress;
    },
    selectChange() {
      if (this.selectType === 2) {
        this.showReceiverAddressBtn = true;
      } else if (this.selectType === 1 && this.isSameAddress) {
        this.showReceiverAddressBtn = false;
      }
    },
    addressHandle() {},
    closeDialog() {},
  },
};
</script>

<style lang="scss">
.repairReq-main {
  .repairReq-main-header {
    text-align: center;
    border-bottom: 1px dashed #eee;
    padding: 30px 0;
  }
  .repairReq-main-step4 {
    .repairReq-main-step4-row + .repairReq-main-step4-row {
      border-top: 1px dashed #eee;
    }
    .repairReq-main-step4-row {
      padding: 30px 0;
      .repairReq-main-step4-left {
        margin-right: 60px;
        > p + p {
          margin-top: 10px;
        }
      }
      .repairReq-main-step4-right {
        .repairReq-step4-address {
          margin-top: 20px;
          .repairReq-step4-address-info {
            margin-top: 20px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
          }
          .repairReq-step4-CollectionTime {
            margin-top: 20px;
            display: flex;
            flex-direction: column;
            .el-date-editor {
              margin-top: 20px;
            }
            .el-select {
              max-width: 220px;
              margin-top: 20px;
            }
          }
          .repairReq-step4-address-tips {
            margin-top: 20px;
          }
        }
      }
    }
  }

  .repairReq-step4-next {
    padding-top: 30px;
    border-top: 1px solid #eee;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
  }
}

.address-dialog {
  .el-dialog {
    min-width: 300px;
    min-height: 360px;
    max-width: 600px;
    max-height: 478px;
    height: 83.3%;
    background-color: #fff;
    width: 95%;
    .el-dialog__body {
      padding: 0;
      height: 75%;
    }
    .address-dialog-form {
      height: 100%;
      padding: 20px;
      overflow-y: auto;
      /* display: flex; */
      /* flex-direction: column; */
      /* overflow: hidden; */
      /* .el-form {
        padding: 0 20px;
      } */
    }
  }
}

@media (max-width: 1000px) {
  .repairReq-main-step4-right {
    margin-top: 20px;
    .repairReq-sn-input {
      flex-direction: column;
      > .el-input {
        width: 100% !important;
      }
      > .el-button {
        margin-top: 20px;
        width: 100% !important;
      }
    }
  }
}

@media (max-width: 700px) {
  .repairReq-step4-next {
    position: absolute;
    left: 0;
    bottom: 10px;
    border: 0 !important;
    padding-top: 0px !important;
    box-shadow: 0 -1px 8px 4px #eee;
    > .el-button {
      flex: 1;
      border-radius: 0;
    }
  }
}
</style>
